import moment from 'moment-jalaali';
import React, { Component } from "react";
import { DateInput } from 'react-hichestan-datetimepicker';
import Fade from 'react-reveal/Fade';
import './DatePicker.css';

class DatePickerClass extends Component {
    datePickerInput(props) {
        return <input className="popo" {...props} />
    }
    handleChange = (event) => {
        this.props.change("", moment(event.target.value).format('jYYYY/jMM/jDD'))
    }
        ;
    render() {
        const invalid = !!this.props.className && this.props.className.split(" ").includes("invalid-date") ? true : false;
        let date = this.props.value != null && this.props.value != '' ? moment(this.props.value, 'jYYYY/jMM/jDD').format('YYYY/M/D') : ''
        return (
            <div className={`col-md-${this.props.col} mb-3 date-small`}>
                <div className="floatLabel">
                    <div>
                        <div className={["DatePicker", this.props.className].join(' ')}>
                            <DateInput value={date} name={'myDateTime'} placeholder="" readOnly={true} autoOk={true} onChange={this.handleChange} />

                        </div>
                    </div>
                    <label htmlFor='car_group' className={this.props.value !== '' && this.props.value !== null ? 'floatLabelWhenValue' : 'label'}>
                        {this.props.placeHolder}
                    </label>
                    <Fade bottom collapse when={invalid}>
                        <div className="invalidFeedback"
                            style={{ display: 'block' }}
                        >
                            الزامی است
                        </div>
                    </Fade>
                </div>
            </div>
        );
    }
}
export default DatePickerClass